export default "__VITE_ASSET__Bcn4LfkZ__"